<template>
  <svg
    class="scene-shape"
    :style="{
      left: `-10px`,
      top: `-10px`,
    }"
    :width="size.width + 20"
    :height="size.height + 20"
    :viewBox="`-10 -10 ${size.width + 20} ${size.height + 20}`"
  >
    <path
      :d="computedPath"
      :fill="fill ?? sceneShapeStore.defaults.fill"
      :stroke="stroke ?? sceneShapeStore.defaults.stroke"
      :stroke-width="strokeWidth ?? sceneShapeStore.defaults.strokeWidth"
      :stroke-dasharray="dasharray ?? ''"
    />
    <slot></slot>
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { createNewShapePath } from "@editor/items/sceneShape/sceneShapeFunctions";
import type { SceneShapeData } from "./sceneShapeData";
import { useSceneShapeStore } from "./sceneShapes.store";
const sceneShapeStore = useSceneShapeStore();

const props = withDefaults(defineProps<{
  size?: { width: number; height: number };
  shapeType?: SceneShapeData['shapeType'];
  fill?: string | null;
  stroke?: string | null;
  strokeWidth?: number | null;
  dasharray?: string;
  path?: string;
}>(), {
  size: () => ({ width: 10, height: 10 }),
});

const computedPath = computed(() => {
  if (props.path) {
    return props.path;
  }
  return createNewShapePath(
    props.shapeType ?? sceneShapeStore.defaults.shapeType,
    props.size.width ?? 10,
    props.size.height ?? 10,
    10
  );
})
</script>